export const buildSecrets = {
    googleMapsApiKey: "AIzaSyBQ05QkYV24eJw8biT2wCNcYVclLNqeR18",
    sentryDsn: "https://6492b3affab7bea4abe06a7cb14b3ffa@o4511732388921344.ingest.de.sentry.io/4511732960002128",
};
